import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Box,
  Typography,
  useTheme,
  Container,
  Grid,
  useMediaQuery,
  Divider,
} from "@material-ui/core";
export default function CourseApply() {
    const theme = useTheme();
    const isPad = useMediaQuery("(max-width:630px)");
  return (
    <Box
      style={{
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <CourseApplyText/>
      <Grid style={{textAlign:'center'}}>
        <Typography
            variant={isPad?"h4":"h2"}
            style={{
            color: theme.palette.secondary.light,
            fontWeight: 700,
            marginBottom: "50px",
            }}
        >
            報名熱線：(04)2471-7673
        </Typography>
      </Grid>
    </Box>
  );
}

function CourseApplyText(){
  const theme = useTheme();
  const isPhone = useMediaQuery("(max-width:320px)");
  const isPad = useMediaQuery("(max-width:630px)");
  const useStyles = makeStyles((theme) => ({
    gridbox: {
      marginBottom: "50px",
      "& .MuiTypography-h6": {
        fontSize: isPhone ? "0.75rem" : isPad ? "1rem" : "1.25rem",
        fontWeight: 700,
      },
      "& .MuiTypography-h2": {
        fontSize: isPhone ? "1.5rem" : isPad ? "2.5rem" : "3.75rem",
        fontWeight: 700,
        marginBottom: "50px",
        color: theme.palette.secondary.light,
      },
      "& .MuiTypography-body1": {
        fontSize: isPhone ? "0.5rem" : isPad ? "0.75rem" : "1rem",
      },
    },
    gridList: {
      display: "flex",
      alignItems: "center",
      height: "auto",
      minHeight:"130px",
      position: "relative",
      "& .MuiTypography-h2": {
        fontSize: isPhone ? "1.5rem" : isPad ? "2.5rem" : "3.75rem",
        fontWeight: 700,
        margin: "40px 0px",
        color: theme.palette.secondary.light,
      },
      "& .MuiTypography-h6": {
        fontSize: isPhone ? "0.75rem" : isPad ? "1rem" : "1.25rem",
        fontWeight: 700,
      },
      "& .MuiTypography-body1": {
        fontSize: isPhone ? "0.5rem" : isPad ? "0.75rem" : "1rem",
      },
    },
    btn: {
      width: isPad ? "120px" : "162px",
      height: isPad ? "38px" : "48px",
      position: isPad ? "" : "absolute",
      bottom: 0,
      right: 0,
      margin: "0px 0px 50px auto",
    },
    btnList: {
      width: isPad ? "120px" : "162px",
      height: isPad ? "38px" : "48px",
      position: isPad ? "" : "absolute",
      bottom: isPad ?0:20,
      right: isPad ?0:7,
      margin: "10px 0px 0px auto",
    },
  }));
  const classes = useStyles();
  const classList = [
  {
    itemNumber:'02',
    itemTitle:'法拍屋入門實戰班',
    itemBody:'每月15日下午2點開課；共2天540分鐘，課程費用特價優惠2000元。'
  },
  {
    itemNumber:'03',
    itemTitle:'法拍公司成立要訣基礎班',
    itemBody:'每月16日上午10點開課；共1天，課程費用特價優惠300元。'
  },
  {
    itemNumber:'04',
    itemTitle:'法拍公司成立要訣進階班',
    itemBody:'每月17日上午10點開課；共2天，課程費用特價優惠1000元。'
  },
  {
    itemNumber:'05',
    itemTitle:'法拍創業開發行銷基礎班',
    itemBody:'每月20日下午2點開課；共1天，課程費用特價優惠600元。'
  },
  {
    itemNumber:'06',
    itemTitle:'法拍創業開發行銷進階班',
    itemBody:'每月21日下午2點開課；共2天，課程費用特價優惠1200元'
  },
  ];

  return (
    <Container maxWidth="md">
      <Box>
        <Grid className={classes.gridbox}>
          <Grid
            style={{
              position: "relative",
              display: "flex",
              flexDirection: " column",
            }}
          >
            <Typography variant="h2" style={{ paddingTop: "50px" }}>
              01
            </Typography>
            <Typography variant="h6">法院拍賣全套實務傳授班</Typography>
            <Typography variant="body1" style={{ marginBottom: "50px" }}>
              最新法拍研究院金磚研習課程：
              <br />
              法院拍賣全套實務傳授 【只要８天您就是行家】
            </Typography>
            <Typography variant="body1" style={{ marginBottom: "50px" }}>
              六大特色:
              <br />
              ◎每週上課二晚，三、五日19:00~22:00，共8天24小時。
              <br />
              ◎法拍全套實務，含作業流程、稅費評估、點交、不點交之分析
              及其應注意事項‧‧‧‧‧‧，結業後即可親自上場操作。
              <br />
              ◎首創:實習輔導中心，免費提供實際操作場所，讓您熟能生巧。
              <br />
              ◎首創:法拍教育研究院，終身研習成長環境。
              <br />
              ◎首創業外實習，人人可學，保證學成。
              <br />
              ◎創業或房仲業、地政士業人士兼差之最佳良機。
              <br />
            </Typography>
            <Typography variant="body1" style={{ marginBottom: "50px" }}>
              費用:7000元(含講義、書籍、雜費)
              <br />
              主辦:富屋專業法拍研習中心
              <br />
              上課兼報名地點:台中市南屯區大英西一街61號
              <br />
              電話:(04)2471-7673 FAX:(04)24757108
              <br />
            </Typography>
            <Button color="primary" variant="contained" className={classes.btn}>
              <Typography variant="h6">購買課程</Typography>
            </Button>
          </Grid>
          <Divider
            variant="middle"
            style={{
              backgroundColor: theme.palette.secondary.light,
              height: "2px",
            }}
          />

          {classList.map((item) => {
            return (
              <>
                <Grid container className={classes.gridList} >
                  <Grid item xs={isPad ? 2 : null}>
                    <Typography variant="h2">{item.itemNumber}</Typography>
                  </Grid>
                  <Grid
                    item
                    xs={isPad ? 10 : null}
                    style={{
                      display: "flex",
                      flexDirection: " column",
                    }}
                  >
                    <Grid>
                      <Typography variant="h6" gutterBottom>
                        {item.itemTitle}
                      </Typography>
                    </Grid>
                    <Grid>
                      <Typography variant="body1">{item.itemBody}</Typography>
                    </Grid>
                    <Grid style={{textAlign:'end'}}>
                      <Button
                        color="primary"
                        variant="contained"
                        className={classes.btnList}
                      >
                        <Typography variant="h6">購買課程</Typography>
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
                <Divider
                  variant="middle"
                  style={{
                    backgroundColor: theme.palette.secondary.light,
                    height: "2px",
                  }}
                />
              </>
            );
          })}
        </Grid>
      </Box>
    </Container>
  );
}